import { Box, styled } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import AgentStore from "./Stores/AgentStore";
import { AgentLogo } from "./Branding/AgentLogo";
import AgentName from "./Branding/AgentName";
import { useOpenCloseFullscreenAgent } from "./AgentUtils";
import { SparklingGradientStar } from "SvgIcons/SparklingGradientStar";

const AgentToggleButton = styled(AcxButton)(() => ({
    background:
        "linear-gradient(131deg, #32D1B7 3.43%, #349AC7 70.89%, #3664D6 100.5%)",
    padding: 0,
}));

const AgentChatMenuIcon = observer(() => {
    const agentStore = useStore(AgentStore);

    const { closeFullscreenAgent } = useOpenCloseFullscreenAgent();

    React.useEffect(() => {
        agentStore.initializeKboUpdateAnnouncement();
    }, [agentStore, agentStore.canOpenKboThroughUI]);

    if (!agentStore.canOpenKboThroughUI) return null;

    return (
        <div
            style={{
                position: "relative",
            }}
        >
            <AgentToggleButton
                fullWidth={false}
                onClick={() => {
                    if (!agentStore.fullscreen) {
                        agentStore.toggleDrawer();
                    } else {
                        closeFullscreenAgent();
                    }
                }}
                id="kbo"
                sx={{
                    gap: 0.75,
                    py: 0.75,
                    px: 1.25,
                    height: "fit-content",
                }}
            >
                <AgentLogo color="white" width="20" height="20" />
                <AgentName color="white" />
            </AgentToggleButton>
            {agentStore.showKboUpdateSparkle && (
                <Box
                    id="kbo-update-sparkle"
                    aria-hidden
                    sx={{
                        position: "absolute",
                        top: "-7px",
                        right: "-7px",
                        height: "22px",
                        width: "22px",
                        boxSizing: "border-box",
                        borderRadius: "50%",
                        border: "2px solid",
                        borderColor: "white.main",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        pointerEvents: "none",
                        backgroundImage:
                            "linear-gradient(135deg, #7A30CA 0%, #239C98 100%)",
                    }}
                >
                    <SparklingGradientStar
                        gradient={false}
                        width={12}
                        height={12}
                        style={{ display: "block", color: "#FFFFFF" }}
                    />
                </Box>
            )}
        </div>
    );
});

export default AgentChatMenuIcon;
